/* src/app/hire-person-search/new-experience-modal/new-experience-modal.component.scss */
.popup-1 {
  position: relative;
  border-radius: 16px;
  background-color: #f5f7fa;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 36px;
  box-sizing: border-box;
  gap: 32px;
  text-align: left;
  font-size: 13px;
  color: #2e93a1;
  font-family: "Poppins", sans-serif;
}
.header-row-parent {
  width: 1054px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.header-row {
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.playful-badge {
  border-radius: 100px;
  background-color: rgba(46, 147, 161, 0.1);
  display: flex;
  align-items: center;
  padding: 8px 16px;
}
.new-experience {
  position: relative;
  font-weight: 500;
}
.article-24dp-fill0-wght400-gra-icon {
  height: 20px;
  width: 20px;
  position: relative;
}
.smarter-search-better-matches-parent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-size: 28px;
  color: #484b59;
}
.smarter-search-better {
  align-self: stretch;
  position: relative;
  line-height: 130%;
  font-weight: 600;
}
.find-better-fit-candidates {
  align-self: stretch;
  position: relative;
  font-size: 20px;
  line-height: 140%;
  font-weight: 500;
}
.frame-parent {
  width: 1054px;
  height: 401px;
  position: relative;
  font-size: 17px;
}
.frame-wrapper {
  position: absolute;
  top: calc(50% - 146.5px);
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 23px;
  flex-shrink: 0;
  color: #484b59;
  font-family: Inter;
}
.features-list-parent {
  width: 268px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 34px;
}
.features-list {
  width: 248px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  font-family: "Poppins", sans-serif;
}
.feature-item-1 {
  display: flex;
  align-items: center;
  gap: 20px;
}
.icon-box {
  height: 48px;
  width: 48px;
  border-radius: 12px;
  background-color: rgba(46, 147, 161, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.magestars-c-fill-icon {
  height: 22px;
  width: 22px;
  position: relative;
  object-fit: contain;
}
.feature-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-weight: 600;
}
.ai-powered-candidate-matching {
  width: 226px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  font-family: "Poppins", sans-serif;
}
.mingcutefile-ai-fill-icon {
  height: 22px;
  width: 22px;
  position: relative;
}
.ai-profile-review {
  align-self: stretch;
  position: relative;
  font-family: "Poppins", sans-serif;
}
.icon-box4 {
  height: 48px;
  width: 48px;
  border-radius: 12px;
  background-color: rgba(46, 147, 161, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.feature-text4 {
  width: 256px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  font-weight: 600;
}
.projects-for-end-to-end {
  width: 201px;
  position: relative;
  display: inline-block;
  font-family: "Poppins", sans-serif;
}
.hero-parent {
  position: absolute;
  top: -18px;
  left: 401.05px;
  width: 652.9px;
  height: 470px;
  flex-shrink: 0;
  font-size: 16px;
}
.hero-icon {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 16px;
  width: 450px;
  height: 342px;
  object-fit: contain;
}
.hero-icon-bg {
  width: 450px;
  height: 342px;
  background: url("./media/New_Experience_2-5UYBPADA.png") 0px 0px/100% 100% no-repeat;
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
  position: absolute;
  left: 202px;
  top: 57px;
}
.group {
  position: absolute;
  top: 372px;
  left: 0px;
  backdrop-filter: blur(5.16px);
  width: 226.9px;
  height: 98px;
}
.market-talent-insights-parent {
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 10.32px;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1.3px solid rgba(239, 242, 248, 0.5);
  box-sizing: border-box;
  width: 226.9px;
  height: 98px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15.5px;
  gap: 2.6px;
}
.market-talent-insights2 {
  position: relative;
  line-height: 25.79px;
  font-weight: 500;
}
.make-informed-decisions {
  width: 196px;
  position: relative;
  font-size: 13px;
  line-height: 19.34px;
  color: #64748b;
  display: inline-block;
}
.group2 {
  position: absolute;
  height: 19.57%;
  width: 26.53%;
  top: 0%;
  right: 55.08%;
  bottom: 80.43%;
  left: 18.39%;
  backdrop-filter: blur(5.14px);
}
.projects-parent {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0%;
  right: 0%;
  bottom: 0%;
  left: 0%;
  border-radius: 10.27px;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1.3px solid rgba(239, 242, 248, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15.4px;
  gap: 2.6px;
}
.projects {
  position: relative;
  line-height: 25.68px;
  font-weight: 500;
  flex-shrink: 0;
}
.one-place-for {
  width: 144px;
  position: relative;
  font-size: 13px;
  line-height: 19.26px;
  color: #64748b;
  display: inline-block;
  flex-shrink: 0;
}
.group3 {
  position: absolute;
  top: 0px;
  left: 408.89px;
  backdrop-filter: blur(4.84px);
  width: 213.1px;
  height: 92px;
}
.ai-profile-review-parent {
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 9.68px;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1.2px solid rgba(239, 242, 248, 0.5);
  box-sizing: border-box;
  width: 213.1px;
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 14.5px;
  gap: 2.4px;
}
.ai-profile-review2 {
  position: relative;
  line-height: 24.21px;
  font-weight: 500;
  flex-shrink: 0;
}
.ai-explains-every {
  width: 184px;
  position: relative;
  font-size: 13px;
  line-height: 18.16px;
  color: #64748b;
  display: inline-block;
  flex-shrink: 0;
}
.group-child {
  position: absolute;
  height: 40.64%;
  width: 15.93%;
  top: 49.79%;
  right: 49.31%;
  bottom: 9.57%;
  left: 34.76%;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.ai-powered-matching-parent {
  position: absolute;
  top: 125px;
  left: 351px;
  border-radius: 9.68px;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1.2px solid rgba(239, 242, 248, 0.5);
  box-sizing: border-box;
  width: 275px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 14.5px;
  gap: 4px;
  flex-shrink: 0;
  font-size: 14.53px;
}
.ai-powered-matching {
  position: relative;
  line-height: 24.21px;
  font-weight: 500;
}
.frame-group {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.8px;
  font-size: 12px;
  color: #64748b;
  font-family: "Poppins", sans-serif;
}
.maya-patel-parent {
  width: 103.2px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
}
.maya-patel {
  align-self: stretch;
  height: 12px;
  position: relative;
  line-height: 150%;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.mayadev {
  align-self: stretch;
  height: 11px;
  position: relative;
  font-size: 11px;
  line-height: 150%;
  font-family: "Poppins", sans-serif;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.button {
  height: 18.5px;
  border-radius: 0px 5.2px 5.2px 0px;
  background-color: rgba(44, 162, 142, 0.1);
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 2.6px 7.8px 2.6px 0px;
  box-sizing: border-box;
  gap: 6.5px;
  text-align: center;
  font-size: 7.8px;
  color: #2ca28e;
}
.button-child {
  height: 18.5px;
  width: 10.2px;
  position: relative;
  flex-shrink: 0;
}
.excellent-fit {
  position: relative;
  line-height: 100%;
  font-weight: 500;
  flex-shrink: 0;
}
.maya-has-over {
  align-self: stretch;
  position: relative;
  font-size: 10px;
  line-height: 150%;
}
.frame-child {
  position: absolute;
  top: 265px;
  left: 495px;
  width: 259px;
  height: 22px;
  flex-shrink: 0;
}
.cta-button {
  border-radius: 6px;
  background-color: #2e93a1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  box-sizing: border-box;
  gap: 8px;
  color: #fff;
  font-size: 13px;
}
.uilcalender-icon {
  height: 20px;
  width: 20px;
  position: relative;
  flex-shrink: 0;
}
.schedule-a-training {
  position: relative;
  font-weight: 600;
  flex-shrink: 0;
}
.no-outline-border-btn {
  outline: none;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
}
.no-outline-border-btn:focus {
  border: none;
  outline: none;
}
/*# sourceMappingURL=new-experience-modal.component-VH3OGUO6.css.map */
